import { Component, Input, OnInit } from '@angular/core';
import { FbSellerInfoConfiguration } from './fb-seller-info.configuration';

@Component({
  selector: 'fb-seller-info',
  templateUrl: './fb-seller-info.component.html',
  styleUrls: ['./fb-seller-info.component.scss']
})
export class FbSellerInfoComponent implements OnInit {

 @Input() configuration! : FbSellerInfoConfiguration;

  constructor() { }

  ngOnInit() {

    if(!this.configuration.avatar){
        this.configuration.avatar = "../../assets/images/profile/default.jpg"
    }

  }

}
